// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Tilbake',
    title: 'Bestillinger',
    pdf: 'PDF',
    detail: 'Detailjer',
    order_time: 'Bestillingsdato/-tid',
    booking_number: 'Billettnr.',
    total: 'Totalt',
    support_status: 'Support',
    email: 'E-post',
    status: 'Status',
    cancelled_at: 'Avbestilt dato/-tid',
    template: 'Billettype',
    customer_name: 'Navn',
    phone_number: 'Mobilnr.',
    created_at: 'Bestillingsdato/-tid',
    country: 'Land',
    locale: 'Språk',
    trips: 'Avreisedato/-tid, reisestrekning',
    no_record: 'Ingen bestillinger funnet i henhold til søket ditt.',
    ticket_total: 'Billett totalt',
    created_at_min: 'Bestillinger fra dato',
    created_at_max: 'Bestillinger til dato',
    cancelled_at_min: 'Avbestillinger fra dato',
    cancelled_at_max: 'Avbestillinger til dato',
    depart_at_min: 'Avreise fra dato',
    depart_at_max: 'Avreise til dato',
    empty_filter: 'Tøm søkefeltene',
    reload: 'Last data på nytt',
    company_name: 'Selskap navn',
    route_name: 'Reisestradenavn'
}
